const initialState = {
  depots: [],
  depot: null,
  loading: false,
  depotLoading: false,
  createLoading: false,
  updateLoading: false,
  deleteLoading: false,
  error: null,
  pageCount: 0,
  total: 0,
};

const depotReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case "FETCH_DEPOTS_LOADING":
      return { ...state, loading: true, error: null };

    case "FETCH_DEPOTS_SUCCESS":
      return {
        ...state,
        loading: false,
        depots: payload.data,
        pageCount: payload.meta?.pagination?.pageCount || 0,
        total: payload.meta?.pagination?.total || 0,
        error: null,
      };

    case "FETCH_DEPOTS_LOAD_MORE_SUCCESS":
      return {
        ...state,
        loading: false,
        depots: [...state.depots, ...payload.data],
        pageCount: payload.meta?.pagination?.pageCount || 0,
        total: payload.meta?.pagination?.total || 0,
        error: null,
      };

    case "FETCH_DEPOTS_ERROR":
      return { ...state, loading: false, error: payload };

    case "FETCH_DEPOT_LOADING":
      return { ...state, depotLoading: true, error: null };

    case "FETCH_DEPOT_SUCCESS":
      return { ...state, depotLoading: false, depot: payload, error: null };

    case "FETCH_DEPOT_ERROR":
      return { ...state, depotLoading: false, error: payload };

    case "CREATE_DEPOT_LOADING":
      return { ...state, createLoading: true, error: null };

    case "CREATE_DEPOT_SUCCESS":
      return {
        ...state,
        createLoading: false,
        depots: [...state.depots, payload],
        depot: payload,
        error: null,
      };

    case "CREATE_DEPOT_ERROR":
      return { ...state, createLoading: false, error: payload };

    case "UPDATE_DEPOT_LOADING":
      return { ...state, updateLoading: true, error: null };

    case "UPDATE_DEPOT_SUCCESS":
      return {
        ...state,
        updateLoading: false,
        depots: state.depots.map((depot) =>
          depot.id === payload.id ? payload : depot
        ),
        depot: state.depot?.id === payload.id ? payload : state.depot,
        error: null,
      };

    case "UPDATE_DEPOT_ERROR":
      return { ...state, updateLoading: false, error: payload };

    case "DELETE_DEPOT_LOADING":
      return { ...state, deleteLoading: true, error: null };

    case "DELETE_DEPOT_SUCCESS":
      return {
        ...state,
        deleteLoading: false,
        depots: state.depots.filter((depot) => depot.id !== payload),
        depot: state.depot?.id === payload ? null : state.depot,
        error: null,
      };

    case "DELETE_DEPOT_ERROR":
      return { ...state, deleteLoading: false, error: payload };

    // case "FETCH_DEPOT_STOREKEEPERS_LOADING":
    //   return { ...state, storekeepersLoading: true, error: null };

    // case "FETCH_DEPOT_STOREKEEPERS_SUCCESS":
    //   return {
    //     ...state,
    //     storekeepersLoading: false,
    //     storekeepers: payload,
    //     error: null,
    //   };

    // case "FETCH_DEPOT_STOREKEEPERS_ERROR":
    //   return { ...state, storekeepersLoading: false, error: payload };

    // // Set selected depot
    // case "SET_SELECTED_DEPOT":
    //   return { ...state, selectedDepot: payload };

    // Clear depot data
    case "REFETCH_DEPOT_SUCCESS": {
      return {
        ...state,
        depots: state.depots.map((depot) =>
          depot.id === payload.id ? payload : depot
        ),
        depot: state.depot?.id === payload.id ? payload : state.depot,
      };
    }
    case "CLEAR_DEPOT_DATA":
      return {
        ...state,
        depot: null,
        error: null,
      };

    default:
      return state;
  }
};

export default depotReducer;
